import React, { useEffect, useState } from "react";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

import { Bar, Line } from "react-chartjs-2";
import { formatToDate } from "../master/FormatToDateTime";
import { closeModal, SweetAlertShow } from "../master/Master";
import { Link } from "react-router-dom";
import { studentTuitionFeeChange } from "../../api/Student";
import OldDueFeeModel from "./OldDueFeeModel";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
);
export default function BasicV2Details({ data, setFilters, handleFunction }) {
  const [modalData, setModalData] = useState({});
  const [loading, setLoading] = useState(false);

  const selected = data?.course_and_fee_info || {};

  const [selectedId, setSelectedId] = useState(0);

  const handleChange = (id) => {
    setSelectedId(id);

    setFilters((prev) => ({
      ...prev,
      course_and_fee_id: id,
    }));
  };

  const handleTuitionFeeChange = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await studentTuitionFeeChange(formData);
      if (response.data.status) {
        closeModal("CourseNFeeUpdate");
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
      handleFunction();
    }
  };

  useEffect(() => {
    if (data?.course_and_fee_info?.id) {
      setSelectedId(data.course_and_fee_info.id);
    }
  }, [data]);

  //// FEES ////

  const regFee = Number(selected?.reg_fee || 0);
  const paidReg = Number(selected?.paid_reg_fee || 0);

  const tuitionFee = Number(selected?.total_fee || 0);
  const paidTuition = Number(selected?.fees_paid || 0);
  const discount = Number(selected?.batch_discount || 0);

  const total = regFee + tuitionFee;
  const paid = paidReg + paidTuition;

  const regDue = regFee - paidReg;
  const batchDue = Number(selected?.left_amount || 0);

  const due = regDue + batchDue;
  const percent = total ? (paid / total) * 100 : 0;

  /// Attendance ////
  const attendance = selected?.attendance || {};

  const attendanceTotal = Number(attendance?.total || 0);
  const present = Number(attendance?.present || 0);
  const absent = Number(attendance?.absent || 0);

  const attendancePercent = attendanceTotal
    ? (present / attendanceTotal) * 100
    : 0;

  //// TEST ///
  const test = selected?.tests || {};

  const testTotal = Number(test?.total || 0);
  const obtained = Number(test?.obtained_total || 0);
  const attempt = Number(test?.attempt || 0);
  const unAttempt = Number(test?.un_attempt || 0);
  const totalMarks = Number(test?.total_marks || 0);

  const avgMarks = attempt ? ((obtained / totalMarks) * 100).toFixed(2) : 0;

  function StudentGraph({
    total,
    paid,
    due,
    attendanceTotal,
    present,
    absent,
    totalMarks,
    obtained,
  }) {
    return (
      <Bar
        data={{
          labels: ["Fees", "Test", "Attendance"],
          datasets: [
            // Fees
            {
              label: "Fees (₹)",
              data: [total, null, null],
              yAxisID: "y1",
              backgroundColor: "rgba(124, 58, 237, 0.7)",
            },
            {
              label: "Paid",
              data: [paid, null, null],
              yAxisID: "y1",
              backgroundColor: "rgba(34, 197, 94, 0.7)",
            },
            {
              label: "Due",
              data: [due, null, null],
              yAxisID: "y1",
              backgroundColor: "rgba(239, 68, 68, 0.7)",
            },

            // Test
            {
              label: "Test Total",
              data: [null, totalMarks, null],
              yAxisID: "y1",
              backgroundColor: "rgba(59, 130, 246, 0.7)",
            },
            {
              label: "Obtained",
              data: [null, obtained, null],
              yAxisID: "y1",
              backgroundColor: "rgba(16, 185, 129, 0.7)",
            },

            // Attendance (END में)
            {
              label: "Attendance Total",
              data: [null, null, attendanceTotal],
              yAxisID: "y2",
              backgroundColor: "rgba(168, 85, 247, 0.7)",
            },
            {
              label: "Present",
              data: [null, null, present],
              yAxisID: "y2",
              backgroundColor: "rgba(34, 197, 94, 0.7)",
            },
            {
              label: "Absent",
              data: [null, null, absent],
              yAxisID: "y2",
              backgroundColor: "rgba(245, 158, 11, 0.7)",
            },
          ],
        }}
        options={{
          responsive: true,
          plugins: {
            legend: {
              position: "top",
              labels: {
                boxWidth: 14,
                font: { size: 12 },
                padding: 8,
              },
            },
          },
          scales: {
            y1: {
              type: "linear",
              position: "left",
              beginAtZero: true,
              title: {
                display: true,
                text: "Fees / Marks",
              },
            },
            y2: {
              type: "linear",
              position: "right",
              beginAtZero: true,
              grid: {
                drawOnChartArea: false,
              },
              title: {
                display: true,
                text: "Attendance",
              },
            },
          },
        }}
      />
    );
  }
  return (
    <>
      <div className="sd-card">
        {/* 🔷 Header */}
        <div className="px-4 py-3 border-bottom">
          <div className="row align-items-center g-3">
            <div className="col-md">
              <h5 className="mb-1 fw-bold">Student Performance Dashboard</h5>

              <small className="text-muted">
                Course, Fee, Attendance & Test Analytics
              </small>
            </div>

            <div className="col-md-auto">
              <div
                className="form-floating form-floating-outline"
                style={{ minWidth: "320px" }}
              >
                <select
                  className="form-select"
                  value={selectedId}
                  onChange={(e) => handleChange(Number(e.target.value))}
                >
                  <option value="">Select Batch</option>

                  {data?.course_and_fees?.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c?.batch?.title} ({c?.course?.title})
                    </option>
                  ))}
                </select>

                <label>Batch</label>
              </div>
            </div>
          </div>
        </div>

        {/* 🔷 Body */}
        <div className="row p-3 g-3">
          {/* KPI Cards */}
          <div className="col-12">
            <div className="row g-3">
              <div className="col-lg-3 col-md-6">
                <div className="card border-0 shadow-sm h-100">
                  <div className="card-body">
                    <small className="text-muted">Total Fee</small>
                    <h4 className="mb-0 fw-bold">₹{total.toLocaleString()}</h4>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="card border-0 shadow-sm h-100">
                  <div className="card-body">
                    <small className="text-muted">Paid Fee</small>
                    <h4 className="mb-0 fw-bold text-success">
                      ₹{paid.toLocaleString()}
                    </h4>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="card border-0 shadow-sm h-100">
                  <div className="card-body">
                    <small className="text-muted">Due Fee</small>
                    <h4 className="mb-0 fw-bold text-danger">
                      ₹{due.toLocaleString()}
                    </h4>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="card border-0 shadow-sm h-100">
                  <div className="card-body">
                    <small className="text-muted">Attendance</small>
                    <h4 className="mb-0 fw-bold text-primary">
                      {attendancePercent.toFixed(1)}%
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* 🔷 LEFT CARD (Fees) */}
          <div className="col-md-6">
            <div
              style={{
                borderRadius: "16px",
                background: "#fff",
                border: "1px solid #e2e8f0",
                boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
                padding: "18px",
                height: "100%",
              }}
            >
              {/* Top */}
              <div className="d-flex justify-content-between align-items-start mb-4">
                <div>
                  <div className="d-flex gap-2 flex-wrap">
                    <span className="badge bg-label-primary">
                      {selected?.course?.title || "-"}
                    </span>

                    <span className="badge bg-label-success">
                      {selected?.batch?.title || "-"}
                    </span>

                    <span className="badge bg-label-info">
                      {selected?.session_year?.session || "-"}
                    </span>
                  </div>
                </div>

                <div className="text-end">
                  <h4 className="fw-bold text-primary mb-0">
                    ₹{total.toLocaleString()}
                  </h4>

                  <small className="text-muted">Total Fees</small>

                  <div>
                    <i
                      className="ri-eye-line fs-5 cursor-pointer"
                      onClick={() => {
                        setModalData(selected);

                        const modal = new window.bootstrap.Modal(
                          document.getElementById("CourseNFeeView"),
                        );

                        modal.show();
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="row g-3">
                <div className="col-6">
                  <div className="border rounded p-3">
                    <small className="text-muted">Registration Fee</small>

                    <div className="fw-bold">₹{regFee}</div>
                  </div>
                </div>

                <div className="col-6">
                  <div className="border rounded p-3">
                    <small className="text-muted">Tuition Fee</small>

                    <div className="fw-bold">₹{tuitionFee}</div>
                  </div>
                </div>

                <div className="col-4">
                  <div className="border rounded p-3 text-success">
                    <small>Paid</small>

                    <div className="fw-bold">₹{paid}</div>
                  </div>
                </div>

                <div className="col-4">
                  <div className="border rounded p-3 text-danger">
                    <small>Due</small>

                    <div className="fw-bold">₹{due}</div>
                  </div>
                </div>

                <div className="col-4">
                  <div className="border rounded p-3 text-warning">
                    <small>Discount</small>

                    <div className="fw-bold">₹{discount}</div>
                  </div>
                </div>
              </div>

              {/* Progress */}
              <div className="mt-2">
                <div
                  style={{
                    height: 6,
                    background: "#eee",
                    borderRadius: 10,
                    overflow: "hidden",
                    paddingRight: "35px",
                  }}
                >
                  <div
                    style={{
                      width: `${Math.min(percent, 100)}%`,
                      background: "#7c3aed",
                      height: "100%",
                      transition: "0.4s ease",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* 🔷 RIGHT CARD (Attendance) */}
          <div className="col-md-6">
            <div
              style={{
                borderRadius: "16px",
                background: "#fff",
                border: "1px solid #e2e8f0",
                boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
                padding: "18px",
                height: "100%",
              }}
            >
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="fw-bold mb-0">Attendance Summary</h6>

                <span className="badge bg-success">
                  {attendancePercent.toFixed(1)}%
                </span>
              </div>

              <div className="row g-3 text-center">
                <div className="col-3">
                  <div className="border rounded p-3 h-100">
                    <div className="fw-bold">{attendanceTotal}</div>
                    <div className="small text-muted">Total</div>
                  </div>
                </div>

                <div className="col-3">
                  <div className="border rounded p-3 h-100">
                    <div className="fw-bold text-success">{present}</div>
                    <div className="small text-muted">Present</div>
                  </div>
                </div>

                <div className="col-3">
                  <div className="border rounded p-3 h-100">
                    <div className="fw-bold text-danger">{absent}</div>
                    <div className="small text-muted">Absent</div>
                  </div>
                </div>

                <div className="col-3">
                  <div className="border rounded p-3 h-100">
                    <div className="fw-bold text-primary">
                      {" "}
                      {attendancePercent.toFixed(1)}%
                    </div>
                    <div className="small text-muted">Avg</div>
                  </div>
                </div>
              </div>

              <div
                style={{
                  height: 6,
                  background: "#eee",
                  borderRadius: 10,
                  marginTop: 10,
                }}
              >
                <div
                  style={{
                    width: `${Math.min(attendancePercent, 100)}%`,
                    background: "#22c55e",
                    height: "100%",
                  }}
                />
              </div>


              {Number(data?.old_due_fees || 0) > 0 && (
                <div className="mt-2 border rounded p-2">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6 className="fw-bold mb-0">Old Fee Details</h6>

                    <i
                      className="ri-edit-box-line fs-5 text-primary cursor-pointer"
                      data-bs-toggle="modal"
                      data-bs-target="#OldDueFeeModel"
                    />
                  </div>

                  <div className="small mb-2">
                    <strong>Remark :</strong>{" "}
                    <span className="text-primary">
                      {data?.old_fees_remark?.length > 45
                        ? `${data.old_fees_remark.substring(0, 45)}...`
                        : data?.old_fees_remark || "-"}
                    </span>
                  </div>

                  <div className="row g-2">
                    <div className="col-6">
                      <div className="border rounded p-2 text-center">
                        <div className="fw-bold text-danger">
                          ₹{Number(data?.old_due_fees || 0).toLocaleString()}
                        </div>
                        <small className="text-muted">Old Due</small>
                      </div>
                    </div>

                    <div className="col-6">
                      <div className="border rounded p-2 text-center">
                        <div className="fw-bold text-success">
                          ₹{Number(data?.old_paid_fees || 0).toLocaleString()}
                        </div>
                        <small className="text-muted">Old Paid</small>
                      </div>
                    </div>
                  </div>
                </div>
              )}

            </div>
          </div>

          {/* 🔷 Test Report FULL WIDTH */}
          <div className="col-12">
            <div
              style={{
                borderRadius: "14px",
                background: "#fff",
                border: "1px solid #e2e8f0",
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                padding: "16px",
              }}
            >
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="fw-bold mb-0">Test Performance</h6>

                <span className="badge bg-primary">{avgMarks}%</span>
              </div>

              <div className="row g-3">
                <div className="col-lg-2 col-md-4 col-6">
                  <div className="border rounded p-3 text-center h-100">
                    <div className="fw-bold">{test?.total || 0}</div>
                    <div className="small text-muted">Total Test</div>
                  </div>
                </div>

                <div className="col-lg-2 col-md-4 col-6">
                  <div className="border rounded p-3 text-center h-100">
                    <div className="fw-bold">{attempt}</div>
                    <div className="small text-muted">Attempted</div>
                  </div>
                </div>
                <div className="col-lg-2 col-md-4 col-6">
                  <div className="border rounded p-3 text-center h-100">
                    <div className="fw-bold">{unAttempt}</div>
                    <div className="small text-muted">Un Attempt</div>
                  </div>
                </div>

                <div className="col-lg-2 col-md-4 col-6">
                  <div className="border rounded p-3 text-center h-100">
                    <div className="fw-bold">{totalMarks}</div>
                    <div className="small text-muted">Total Marks</div>
                  </div>
                </div>

                <div className="col-lg-2 col-md-4 col-6">
                  <div className="border rounded p-3 text-center h-100">
                    <div className="fw-bold">{obtained}</div>
                    <div className="small text-muted">Obtained</div>
                  </div>
                </div>

                <div className="col-lg-2 col-md-4 col-6">
                  <div className="border rounded p-3 text-center h-100">
                    <div className="fw-bold text-primary">{avgMarks}%</div>
                    <div className="small text-muted">Average</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 mt-2">
            <div
              style={{
                borderRadius: "16px",
                background: "#fff",
                border: "1px solid #e2e8f0",
                boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
                padding: "18px",
              }}
            >
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="fw-bold mb-0">Performance Analytics</h6>

                <small className="text-muted">
                  Fees vs Attendance vs Tests
                </small>
              </div>

              <StudentGraph
                total={total}
                paid={paid}
                due={due}
                attendanceTotal={attendanceTotal}
                present={present}
                absent={absent}
                totalMarks={totalMarks}
                obtained={obtained}
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="CourseNFeeView"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header py-3 bg-label-primary">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Batch Details
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row g-5">
                <div className="col-md-6">
                  <h6 className="text-primary">Basic Info</h6>
                  <p>
                    <strong>Roll No:</strong> {modalData.roll_number}
                  </p>
                  <p>
                    <strong>Admission Date:</strong>{" "}
                    {formatToDate(modalData.admission_date)}
                  </p>
                  <p>
                    <strong>Status:</strong>{" "}
                    {Number(modalData?.status) === 1 &&
                      (Number(modalData?.batch?.status) === 0 ||
                        Number(modalData?.batch?.status) === 1)
                      ? "Active"
                      : Number(modalData?.status) === 1 &&
                        Number(modalData?.batch?.status) === 2
                        ? "Finished"
                        : Number(modalData.status) === 4
                          ? "Transferred"
                          : "Inactive"}
                  </p>
                </div>

                {/* Course Info */}
                <div className="col-md-6">
                  <h6 className="text-primary">Course Info</h6>
                  <p>
                    <strong>Session:</strong> {modalData.session_year?.session}
                  </p>
                  <p>
                    <strong>Course:</strong> {modalData.course?.title}
                  </p>
                  <p>
                    <strong>Batch:</strong> {modalData.batch?.title}
                  </p>
                </div>

                {/* Fee Info */}
                <div className="col-md-6">
                  <h6 className="text-primary">Fee Details</h6>
                  <p>
                    <strong>Registration Fee:</strong> ₹{modalData?.reg_fee} /{" "}
                    <span className="text-success">
                      ₹{modalData?.paid_reg_fee}
                    </span>
                  </p>
                  <p>
                    <strong>Total Tuition Fee:</strong> ₹{modalData.batch_fees}
                  </p>
                  <p>
                    <strong>Tuition Fee Discount:</strong> ₹
                    {modalData.batch_discount}
                  </p>



                  <p>
                    <strong>Final Tuition Fee:</strong> ₹{modalData?.total_fee}{" "}
                    /{" "}
                    <span className="text-success">
                      ₹{modalData?.fees_paid}
                    </span>
                  </p>
                </div>



                <div className="col-md-6">
                  {modalData?.bus_fees > 0 && (
                    <>
                      <p>
                        <strong>Total Transport Fee:</strong> ₹
                        {modalData.bus_fees}
                      </p>
                      <p>
                        <strong>Transport Fee Discount:</strong> ₹
                        {modalData.bus_discount}
                      </p>


                      <p>
                        <strong>Final Transport Fee:</strong> ₹
                        {modalData?.bus_final_fees} /{" "}
                        <span className="text-success">
                          ₹{modalData?.bus_paid_fees}
                        </span>
                      </p>
                    </>
                  )}
                  <p className="fw-bold fs-5 text-primary">
                    <strong>Total Fee:</strong> ₹
                    {Number(modalData?.total_fee) +
                      Number(modalData.reg_fee) +
                      Number(modalData?.bus_final_fees)}{" "}
                    / ₹
                    {Number(modalData?.fees_paid) +
                      Number(modalData?.paid_reg_fee) +
                      Number(modalData?.bus_paid_fees)}
                  </p>





                  {modalData?.discount_remark && (
                    <div className="alert alert-warning mb-0">
                      <h6 className="alert-heading mb-2">
                        <i className="bx bx-message-detail me-2"></i>
                        Discount Remark
                      </h6>

                      <div
                        style={{
                          whiteSpace: "pre-wrap",
                          wordBreak: "break-word",
                        }}
                      >
                        {modalData.discount_remark}
                      </div>
                    </div>
                  )}



                </div>
              </div>
            </div>
            <div className="modal-footer py-3 bg-label-primary">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-info"
                data-bs-toggle="modal"
                data-bs-target="#CourseNFeeUpdate"
                onClick={() => closeModal("CourseNFeeView")}
              >
                Update Fee Detail
              </button>
              {Number(modalData?.status) === 1 && (
                <Link
                  onClick={() => closeModal("CourseNFeeView")}
                  to={`/student/batch/transfer?batch=${modalData?.batch_id}&course_n_fee_id=${modalData?.id}`}
                  className="btn btn-primary"
                >
                  Transfer Batch
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="CourseNFeeUpdate"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={handleTuitionFeeChange} method="post">
              <div className="modal-header py-3 bg-label-primary">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Tuition Fee Change
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row g-5">
                  <div className="col-12">
                    <h5 className="text-primary m-0">Course Info</h5>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <strong>Session:</strong>{" "}
                      {modalData.session_year?.session}
                    </p>
                    <p>
                      <strong>Course:</strong> {modalData.course?.title}
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <strong>Batch:</strong> {modalData.batch?.title}
                    </p>
                    <p>
                      <strong>Total Tuition Fee:</strong> ₹
                      {modalData.batch_fees}
                    </p>
                  </div>

                  <div className="col-md-12">
                    <hr className="m-0" />
                  </div>
                  <div className="col-md-6">
                    <input
                      name="student_id"
                      id="student_id"
                      type="hidden"
                      className="form-control"
                      value={modalData?.student_id}
                    />
                    <input
                      name="course_n_fee_id"
                      id="course_n_fee_id"
                      type="hidden"
                      className="form-control"
                      value={modalData?.id}
                    />
                    <div className="form-floating form-floating-outline">
                      <select
                        name="rte_status"
                        id="rte_status"
                        className="form-select"
                        value={modalData?.rte || "NON-RTE"}
                        onChange={(e) =>
                          setModalData({
                            ...modalData,
                            rte: e.target.value,
                          })
                        }
                      >
                        <option value="" disabled>
                          Select RTE Status
                        </option>

                        <option value="RTE">RTE</option>

                        <option value="NON-RTE">NON-RTE</option>
                      </select>
                      <label htmlFor=""> Select RTE Status</label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        name="final_fee"
                        id="final_fee"
                        type="number"
                        className="form-control"
                        value={modalData?.total_fee}
                        placeholder="Final Tuition Fee"
                        onChange={(e) =>
                          setModalData({
                            ...modalData,
                            total_fee: e.target.value,
                          })
                        }
                        required
                      />
                      <label htmlFor="">Final Tuition Fee</label>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="form-floating form-floating-outline">
                      <textarea
                        name="discount_remark"
                        id="discount_remark"
                        className="form-control input-uppercase"
                        placeholder="Discount Remark"
                        required
                      />
                      <label htmlFor="">Discount Remark</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer py-3 bg-label-primary">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-info">
                  Update Details
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <OldDueFeeModel
        data={data}
        handleFunction={handleFunction}
      />
    </>
  );
}
